export type SelectOption = {
  label: string;
  value: string;
};

export function isSelectOption(value: unknown): value is SelectOption {
  return typeof value === 'object' && value !== null && 'label' in value && 'value' in value;
}
